// AUTO-GENERATED by scripts/generate-brand-registry.js — do not edit by hand.
// Source: bowtackle_brand_logos/00_MANIFEST.txt
// Re-run: node scripts/generate-brand-registry.js
//
// `name`  is the display label (proper case) shown in the UI.
// `value` is the canonical lowercase brand stored in publicData.brand and used
//          to filter (pub_brand). Feeds are lowercased on ingest to match this.
// `logo`  is a statically-served asset; placeholders render via BrandPlaceholder.

export const BRANDS = [
  {
    "name": "365 Archery",
    "value": "365 archery",
    "slug": "365-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/365_Archery.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "3Rivers Archery",
    "value": "3rivers archery",
    "slug": "3rivers-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/3Rivers_Archery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Adamsbuilt Fishing",
    "value": "adamsbuilt fishing",
    "slug": "adamsbuilt-fishing",
    "category": "Fishing",
    "logo": "/static/brands/Adamsbuilt_Fishing_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "AMS LLC",
    "value": "ams llc",
    "slug": "ams-llc",
    "category": "Archery Specialty",
    "logo": "/static/brands/AMS_LLC_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Arizona Archery Enterprises",
    "value": "arizona archery enterprises",
    "slug": "arizona-archery-enterprises",
    "category": "Archery Specialty",
    "logo": "/static/brands/Arizona_Archery_Enterprises_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Axcel Archery",
    "value": "axcel archery",
    "slug": "axcel-archery",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Axcel_Archery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Badlands Gear Co",
    "value": "badlands gear co",
    "slug": "badlands-gear-co",
    "category": "Camo & Apparel",
    "logo": "/static/brands/Badlands_Gear_Co.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Barnett Outdoors",
    "value": "barnett outdoors",
    "slug": "barnett-outdoors",
    "category": "Archery Bows",
    "logo": "/static/brands/Barnett_Outdoors.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "BCY Inc",
    "value": "bcy inc",
    "slug": "bcy-inc",
    "category": "Fletching & Strings",
    "logo": "/static/brands/BCY_Inc.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Bear Archery",
    "value": "bear archery",
    "slug": "bear-archery",
    "category": "Archery Bows",
    "logo": "/static/brands/Bear_Archery.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Bearpaw",
    "value": "bearpaw",
    "slug": "bearpaw",
    "category": "Archery Specialty",
    "logo": "/static/brands/Bearpaw_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Big Shot Targets",
    "value": "big shot targets",
    "slug": "big-shot-targets",
    "category": "Targets",
    "logo": "/static/brands/Big_Shot_Targets_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Black Widow Custom Bows",
    "value": "black widow custom bows",
    "slug": "black-widow-custom-bows",
    "category": "Archery Bows",
    "logo": "/static/brands/Black_Widow_Custom_Bows.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Bohning Co Inc",
    "value": "bohning co inc",
    "slug": "bohning-co-inc",
    "category": "Fletching & Strings",
    "logo": "/static/brands/Bohning_Co_Inc.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Bowmar",
    "value": "bowmar",
    "slug": "bowmar",
    "category": "Archery Bows",
    "logo": "/static/brands/Bowmar.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Bowtackle",
    "value": "bowtackle",
    "slug": "bowtackle",
    "category": "Other Brands",
    "logo": "/static/brands/Bowtackle.png",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Bowtech",
    "value": "bowtech",
    "slug": "bowtech",
    "category": "Archery Bows",
    "logo": "/static/brands/Bowtech.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Brownell & Co",
    "value": "brownell & co",
    "slug": "brownell-and-co",
    "category": "Fletching & Strings",
    "logo": "/static/brands/Brownell___Co_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Brumate",
    "value": "brumate",
    "slug": "brumate",
    "category": "General Outdoor",
    "logo": "/static/brands/Brumate.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Burt Coyote Company",
    "value": "burt coyote company",
    "slug": "burt-coyote-company",
    "category": "Other Brands",
    "logo": "/static/brands/Burt_Coyote_Company.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Bwana",
    "value": "bwana",
    "slug": "bwana",
    "category": "Other Brands",
    "logo": "/static/brands/Bwana_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Canyon Coolers",
    "value": "canyon coolers",
    "slug": "canyon-coolers",
    "category": "General Outdoor",
    "logo": "/static/brands/Canyon_Coolers.png",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Carbon Express",
    "value": "carbon express",
    "slug": "carbon-express",
    "category": "Arrows & Shafts",
    "logo": "/static/brands/Carbon_Express.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Carter Enterprises",
    "value": "carter enterprises",
    "slug": "carter-enterprises",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Carter_Enterprises.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Cascade Mountain Tech",
    "value": "cascade mountain tech",
    "slug": "cascade-mountain-tech",
    "category": "General Outdoor",
    "logo": "/static/brands/Cascade_Mountain_Tech.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Cobra Mfg Company",
    "value": "cobra mfg company",
    "slug": "cobra-mfg-company",
    "category": "Other Brands",
    "logo": "/static/brands/Cobra_Mfg_Company_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Crosman Corp",
    "value": "crosman corp",
    "slug": "crosman-corp",
    "category": "Ammunition & Firearms",
    "logo": "/static/brands/Crosman_Corp.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Darn Tough",
    "value": "darn tough",
    "slug": "darn-tough",
    "category": "General Outdoor",
    "logo": "/static/brands/Darn_Tough.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Decut Archery",
    "value": "decut archery",
    "slug": "decut-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Decut_Archery_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Delta Sports Products",
    "value": "delta sports products",
    "slug": "delta-sports-products",
    "category": "Targets",
    "logo": "/static/brands/Delta_Sports_Products_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Doubletake Archery",
    "value": "doubletake archery",
    "slug": "doubletake-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Doubletake_Archery_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Eagle Claw",
    "value": "eagle claw",
    "slug": "eagle-claw",
    "category": "Fishing",
    "logo": "/static/brands/Eagle_Claw.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Easton Technical Products",
    "value": "easton technical products",
    "slug": "easton-technical-products",
    "category": "Arrows & Shafts",
    "logo": "/static/brands/Easton_Technical_Products.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Eberlestock",
    "value": "eberlestock",
    "slug": "eberlestock",
    "category": "Camo & Apparel",
    "logo": "/static/brands/Eberlestock.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Energizer",
    "value": "energizer",
    "slug": "energizer",
    "category": "General Outdoor",
    "logo": "/static/brands/Energizer.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Feradyne Outdoors",
    "value": "feradyne outdoors",
    "slug": "feradyne-outdoors",
    "category": "Other Brands",
    "logo": "/static/brands/Feradyne_Outdoors.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Fieldsheer",
    "value": "fieldsheer",
    "slug": "fieldsheer",
    "category": "Camo & Apparel",
    "logo": "/static/brands/Fieldsheer.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Flex-Fletch Products",
    "value": "flex-fletch products",
    "slug": "flex-fletch-products",
    "category": "Fletching & Strings",
    "logo": "/static/brands/Flex-Fletch_Products.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Frogg Toggs",
    "value": "frogg toggs",
    "slug": "frogg-toggs",
    "category": "General Outdoor",
    "logo": "/static/brands/Frogg_Toggs.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "G5 Outdoors",
    "value": "g5 outdoors",
    "slug": "g5-outdoors",
    "category": "Broadheads",
    "logo": "/static/brands/G5_Outdoors.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Garmin",
    "value": "garmin",
    "slug": "garmin",
    "category": "General Outdoor",
    "logo": "/static/brands/Garmin.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Gold Tip",
    "value": "gold tip",
    "slug": "gold-tip",
    "category": "Arrows & Shafts",
    "logo": "/static/brands/Gold_Tip.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Greatree Archery",
    "value": "greatree archery",
    "slug": "greatree-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Greatree_Archery.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Grim Reaper",
    "value": "grim reaper",
    "slug": "grim-reaper",
    "category": "Broadheads",
    "logo": "/static/brands/Grim_Reaper.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Hamskea Archery Solutions",
    "value": "hamskea archery solutions",
    "slug": "hamskea-archery-solutions",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Hamskea_Archery_Solutions_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Hawke Optics",
    "value": "hawke optics",
    "slug": "hawke-optics",
    "category": "Optics",
    "logo": "/static/brands/Hawke_Optics.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "HCO Outdoors",
    "value": "hco outdoors",
    "slug": "hco-outdoors",
    "category": "Hunting Accessories",
    "logo": "/static/brands/HCO_Outdoors.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "HME Products",
    "value": "hme products",
    "slug": "hme-products",
    "category": "Hunting Accessories",
    "logo": "/static/brands/HME_Products.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Hornady",
    "value": "hornady",
    "slug": "hornady",
    "category": "Ammunition & Firearms",
    "logo": "/static/brands/Hornady.png",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Hot Shot Mfg",
    "value": "hot shot mfg",
    "slug": "hot-shot-mfg",
    "category": "Other Brands",
    "logo": "/static/brands/Hot_Shot_Mfg.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Hoyt Archery",
    "value": "hoyt archery",
    "slug": "hoyt-archery",
    "category": "Archery Bows",
    "logo": "/static/brands/Hoyt_Archery.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Hunters Specialties",
    "value": "hunters specialties",
    "slug": "hunters-specialties",
    "category": "Hunting Accessories",
    "logo": "/static/brands/Hunters_Specialties.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Johnson Outdoors",
    "value": "johnson outdoors",
    "slug": "johnson-outdoors",
    "category": "General Outdoor",
    "logo": "/static/brands/Johnson_Outdoors.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Kings Camo",
    "value": "kings camo",
    "slug": "kings-camo",
    "category": "Camo & Apparel",
    "logo": "/static/brands/Kings_Camo.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Kinsey Archery",
    "value": "kinsey archery",
    "slug": "kinsey-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Kinsey_Archery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Knives Of Alaska",
    "value": "knives of alaska",
    "slug": "knives-of-alaska",
    "category": "Knives & Tools",
    "logo": "/static/brands/Knives_Of_Alaska.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Koola Buck",
    "value": "koola buck",
    "slug": "koola-buck",
    "category": "Other Brands",
    "logo": "/static/brands/Koola_Buck.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "LaCrosse Footwear",
    "value": "lacrosse footwear",
    "slug": "lacrosse-footwear",
    "category": "General Outdoor",
    "logo": "/static/brands/LaCrosse_Footwear.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Lancaster Archery Supply",
    "value": "lancaster archery supply",
    "slug": "lancaster-archery-supply",
    "category": "Archery Specialty",
    "logo": "/static/brands/Lancaster_Archery_Supply.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Last Chance Archery",
    "value": "last chance archery",
    "slug": "last-chance-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Last_Chance_Archery.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Leupold & Stevens",
    "value": "leupold & stevens",
    "slug": "leupold-and-stevens",
    "category": "Optics",
    "logo": "/static/brands/Leupold___Stevens.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Liberty Mountain",
    "value": "liberty mountain",
    "slug": "liberty-mountain",
    "category": "General Outdoor",
    "logo": "/static/brands/Liberty_Mountain.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Magnus Outdoor Products",
    "value": "magnus outdoor products",
    "slug": "magnus-outdoor-products",
    "category": "Broadheads",
    "logo": "/static/brands/Magnus_Outdoor_Products.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Mathews Inc",
    "value": "mathews inc",
    "slug": "mathews-inc",
    "category": "Archery Bows",
    "logo": "/static/brands/Mathews_Inc.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Montana Black Gold",
    "value": "montana black gold",
    "slug": "montana-black-gold",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Montana_Black_Gold.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Montana Decoy",
    "value": "montana decoy",
    "slug": "montana-decoy",
    "category": "Hunting Accessories",
    "logo": "/static/brands/Montana_Decoy.png",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Morrell Mfg",
    "value": "morrell mfg",
    "slug": "morrell-mfg",
    "category": "Targets",
    "logo": "/static/brands/Morrell_Mfg.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "MTM Molded Products",
    "value": "mtm molded products",
    "slug": "mtm-molded-products",
    "category": "Other Brands",
    "logo": "/static/brands/MTM_Molded_Products.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Mtn Ops",
    "value": "mtn ops",
    "slug": "mtn-ops",
    "category": "Hunting Accessories",
    "logo": "/static/brands/Mtn_Ops.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Mystery Ranch",
    "value": "mystery ranch",
    "slug": "mystery-ranch",
    "category": "Camo & Apparel",
    "logo": "/static/brands/Mystery_Ranch.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Nikon",
    "value": "nikon",
    "slug": "nikon",
    "category": "Optics",
    "logo": "/static/brands/Nikon.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Nite Ize",
    "value": "nite ize",
    "slug": "nite-ize",
    "category": "General Outdoor",
    "logo": "/static/brands/Nite_Ize.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Nosler Inc",
    "value": "nosler inc",
    "slug": "nosler-inc",
    "category": "Ammunition & Firearms",
    "logo": "/static/brands/Nosler_Inc.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Obsession Bows",
    "value": "obsession bows",
    "slug": "obsession-bows",
    "category": "Archery Bows",
    "logo": "/static/brands/Obsession_Bows.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Outdoor Edge Cutlery",
    "value": "outdoor edge cutlery",
    "slug": "outdoor-edge-cutlery",
    "category": "Knives & Tools",
    "logo": "/static/brands/Outdoor_Edge_Cutlery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Peak Refuel",
    "value": "peak refuel",
    "slug": "peak-refuel",
    "category": "General Outdoor",
    "logo": "/static/brands/Peak_Refuel.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Pelican Products",
    "value": "pelican products",
    "slug": "pelican-products",
    "category": "General Outdoor",
    "logo": "/static/brands/Pelican_Products.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Pine Ridge Archery",
    "value": "pine ridge archery",
    "slug": "pine-ridge-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Pine_Ridge_Archery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Plano Molding Company",
    "value": "plano molding company",
    "slug": "plano-molding-company",
    "category": "Quivers & Cases",
    "logo": "/static/brands/Plano_Molding_Company.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Princeton Tec",
    "value": "princeton tec",
    "slug": "princeton-tec",
    "category": "General Outdoor",
    "logo": "/static/brands/Princeton_Tec.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "QAD Inc",
    "value": "qad inc",
    "slug": "qad-inc",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/QAD_Inc.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Radical Archery Design",
    "value": "radical archery design",
    "slug": "radical-archery-design",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Radical_Archery_Design.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Rapala",
    "value": "rapala",
    "slug": "rapala",
    "category": "Fishing",
    "logo": "/static/brands/Rapala.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Ravin Crossbows",
    "value": "ravin crossbows",
    "slug": "ravin-crossbows",
    "category": "Archery Bows",
    "logo": "/static/brands/Ravin_Crossbows.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Realtree",
    "value": "realtree",
    "slug": "realtree",
    "category": "Camo & Apparel",
    "logo": "/static/brands/Realtree.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Rinehart Targets",
    "value": "rinehart targets",
    "slug": "rinehart-targets",
    "category": "Targets",
    "logo": "/static/brands/Rinehart_Targets_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Ripcord Technologies",
    "value": "ripcord technologies",
    "slug": "ripcord-technologies",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Ripcord_Technologies.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Sanlida Archery",
    "value": "sanlida archery",
    "slug": "sanlida-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Sanlida_Archery_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Saunders Archery",
    "value": "saunders archery",
    "slug": "saunders-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Saunders_Archery.png",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Savage Arms",
    "value": "savage arms",
    "slug": "savage-arms",
    "category": "Ammunition & Firearms",
    "logo": "/static/brands/Savage_Arms.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Selway Archery",
    "value": "selway archery",
    "slug": "selway-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Selway_Archery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Sims Vibration Labs",
    "value": "sims vibration labs",
    "slug": "sims-vibration-labs",
    "category": "Archery Specialty",
    "logo": "/static/brands/Sims_Vibration_Labs_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "SKB Corporation",
    "value": "skb corporation",
    "slug": "skb-corporation",
    "category": "Quivers & Cases",
    "logo": "/static/brands/SKB_Corporation.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Slumberjack",
    "value": "slumberjack",
    "slug": "slumberjack",
    "category": "General Outdoor",
    "logo": "/static/brands/Slumberjack.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Smith Sport Optics",
    "value": "smith sport optics",
    "slug": "smith-sport-optics",
    "category": "Optics",
    "logo": "/static/brands/Smith_Sport_Optics.svg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Specialty Archery",
    "value": "specialty archery",
    "slug": "specialty-archery",
    "category": "Archery Specialty",
    "logo": "/static/brands/Specialty_Archery_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Spot-Hogg",
    "value": "spot-hogg",
    "slug": "spot-hogg",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Spot-Hogg.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Spyderco",
    "value": "spyderco",
    "slug": "spyderco",
    "category": "Knives & Tools",
    "logo": "/static/brands/Spyderco.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "St Croix Rods",
    "value": "st croix rods",
    "slug": "st-croix-rods",
    "category": "Fishing",
    "logo": "/static/brands/St_Croix_Rods.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Stone Glacier",
    "value": "stone glacier",
    "slug": "stone-glacier",
    "category": "Camo & Apparel",
    "logo": "/static/brands/Stone_Glacier.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "T.R.U. Ball",
    "value": "t.r.u. ball",
    "slug": "t-r-u-ball",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/T.R.U._Ball.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Tactacam",
    "value": "tactacam",
    "slug": "tactacam",
    "category": "Hunting Accessories",
    "logo": "/static/brands/Tactacam.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Thermacell",
    "value": "thermacell",
    "slug": "thermacell",
    "category": "Hunting Accessories",
    "logo": "/static/brands/Thermacell.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Tight Spot Quivers",
    "value": "tight spot quivers",
    "slug": "tight-spot-quivers",
    "category": "Quivers & Cases",
    "logo": "/static/brands/Tight_Spot_Quivers.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Trueflight Manufacturing",
    "value": "trueflight manufacturing",
    "slug": "trueflight-manufacturing",
    "category": "Fletching & Strings",
    "logo": "/static/brands/Trueflight_Manufacturing_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Truglo Inc",
    "value": "truglo inc",
    "slug": "truglo-inc",
    "category": "Archery Specialty",
    "logo": "/static/brands/Truglo_Inc.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "U-Nique Archery Products",
    "value": "u-nique archery products",
    "slug": "u-nique-archery-products",
    "category": "Archery Specialty",
    "logo": "/static/brands/U-Nique_Archery_Products_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Ultraview Archery",
    "value": "ultraview archery",
    "slug": "ultraview-archery",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Ultraview_Archery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Umarex USA",
    "value": "umarex usa",
    "slug": "umarex-usa",
    "category": "Ammunition & Firearms",
    "logo": "/static/brands/Umarex_USA.png",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Vanguard",
    "value": "vanguard",
    "slug": "vanguard",
    "category": "Other Brands",
    "logo": "/static/brands/Vanguard.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Vantage Point Archery",
    "value": "vantage point archery",
    "slug": "vantage-point-archery",
    "category": "Sights Rests Releases",
    "logo": "/static/brands/Vantage_Point_Archery_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  },
  {
    "name": "Victory Archery",
    "value": "victory archery",
    "slug": "victory-archery",
    "category": "Arrows & Shafts",
    "logo": "/static/brands/Victory_Archery.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Vortex Optics",
    "value": "vortex optics",
    "slug": "vortex-optics",
    "category": "Optics",
    "logo": "/static/brands/Vortex_Optics.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Warne Mounts",
    "value": "warne mounts",
    "slug": "warne-mounts",
    "category": "Other Brands",
    "logo": "/static/brands/Warne_Mounts.svg",
    "tile": "dark",
    "isPlaceholder": false
  },
  {
    "name": "Wildlife Research",
    "value": "wildlife research",
    "slug": "wildlife-research",
    "category": "Hunting Accessories",
    "logo": "/static/brands/Wildlife_Research.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Yukon Outfitters",
    "value": "yukon outfitters",
    "slug": "yukon-outfitters",
    "category": "Other Brands",
    "logo": "/static/brands/Yukon_Outfitters.png",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Zeiss",
    "value": "zeiss",
    "slug": "zeiss",
    "category": "Optics",
    "logo": "/static/brands/Zeiss.jpg",
    "tile": "light",
    "isPlaceholder": false
  },
  {
    "name": "Zwickey Archery",
    "value": "zwickey archery",
    "slug": "zwickey-archery",
    "category": "Broadheads",
    "logo": "/static/brands/Zwickey_Archery_placeholder.svg",
    "tile": "light",
    "isPlaceholder": true
  }
];

export const BRANDS_BY_VALUE = BRANDS.reduce((acc, b) => {
  acc[b.value] = b;
  return acc;
}, {});

// Look up a brand by its canonical lowercase value (e.g. from pub_brand).
export const getBrandByValue = value =>
  value == null ? null : BRANDS_BY_VALUE[String(value).trim().toLowerCase()] || null;

// Display label for a stored/lowercase brand value; falls back to the value itself.
export const brandLabel = value => {
  const b = getBrandByValue(value);
  return b ? b.name : value || '';
};
